import React from 'react';
import { TabsOrentations } from '../MTabs.model';

import MTabsNavView from './MTabsNav.view';

type Props<Tabs extends string> = {
  activeTab: Tabs;
  classNameItem?: string;
  classNameItemSelected?: string;
  className?: string;
  orientation?: TabsOrentations;
  onTabClick: (tab: Tabs) => void;
};

const MTabsNav = <Tabs extends string>(props: React.PropsWithChildren<Props<Tabs>>): JSX.Element => {
  return (
    <MTabsNavView
      className={props.className}
      activeTab={props.activeTab}
      orientation={props.orientation}
      classNameItem={props.classNameItem}
      classNameItemSelected={props.classNameItemSelected}
      onTabClick={props.onTabClick}
    >
      {props.children}
    </MTabsNavView>
  );
};

MTabsNav.displayName = 'MTabsNav';

export default MTabsNav;
